import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { TSLRange } from '../types';

interface DynamicTSLRangesProps {
  xValue: number;
  tslRanges: TSLRange[];
  onChange: (ranges: TSLRange[]) => void;
}

const DynamicTSLRanges: React.FC<DynamicTSLRangesProps> = ({ xValue, tslRanges, onChange }) => {
  const addRange = () => {
    const lastRange = tslRanges[tslRanges.length - 1];
    const newRange: TSLRange = {
      entry_start: lastRange ? lastRange.entry_peak + 1 : xValue,
      entry_peak: lastRange ? lastRange.entry_peak + 20 : xValue + 20,
      range: 4
    };
    onChange([...tslRanges, newRange]);
  };

  const removeRange = (index: number) => {
    if (tslRanges.length > 1) {
      onChange(tslRanges.filter((_, i) => i !== index));
    }
  };

  const updateRange = (index: number, field: keyof TSLRange, value: number) => {
    const updated = [...tslRanges];
    updated[index] = { ...updated[index], [field]: value };
    
    // Auto-update next entry_start
    if (field === 'entry_peak' && index < tslRanges.length - 1) {
      updated[index + 1] = { ...updated[index + 1], entry_start: value + 1 };
    }
    
    onChange(updated);
  };

  // Update first range entry_start when xValue changes
  React.useEffect(() => {
    if (tslRanges.length > 0 && tslRanges[0].entry_start !== xValue) {
      const updated = [...tslRanges];
      updated[0] = { ...updated[0], entry_start: xValue };
      onChange(updated);
    }
  }, [xValue]);

  return (
    <div>
      {tslRanges.slice(1).map((range, i) => {
        const index = i + 1;
        return (
        <div key={index} style={{ display: 'flex', gap: '6px', marginBottom: '6px', alignItems: 'center' }}>
          <input
            type="number"
            value={range.entry_start}
            onChange={(e) => updateRange(index, 'entry_start', parseFloat(e.target.value))}
            style={{ width: '50px', padding: '3px 4px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '11px' }}
            step="1"
          />
          <input
            type="number"
            value={range.entry_peak}
            onChange={(e) => updateRange(index, 'entry_peak', parseFloat(e.target.value))}
            style={{ width: '50px', padding: '3px 4px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '11px' }}
            step="1"
          />
          <input
            type="number"
            value={range.range}
            onChange={(e) => updateRange(index, 'range', parseFloat(e.target.value))}
            style={{ width: '45px', padding: '3px 4px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '11px' }}
            step="1"
          />
          <button
            type="button"
            onClick={() => removeRange(index)}
            style={{ padding: '4px', border: 'none', borderRadius: '4px', backgroundColor: '#fee2e2', color: '#dc2626', cursor: 'pointer' }}
            title="Remove range"
          >
            <Trash2 size={14} />
          </button>
        </div>
        );
      })}
      <button
        type="button"
        onClick={addRange}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '4px 8px',
          border: '1px dashed #3b82f6',
          borderRadius: '4px',
          backgroundColor: 'white',
          color: '#3b82f6',
          fontSize: '11px',
          cursor: 'pointer',
          marginTop: '4px'
        }}
      >
        <Plus size={12} /> Add Range
      </button>
    </div>
  );
};

export default DynamicTSLRanges;
